/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateSigintSignalForm,
  UpdateSigintSignalForm$Outbound,
  UpdateSigintSignalForm$outboundSchema,
} from "../components/updatesigintsignalform.js";

export type UpdateSigintSignalSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateSigintSignalSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateSigintSignalSecurity = {
  option1?: UpdateSigintSignalSecurityOption1 | undefined;
  option2?: UpdateSigintSignalSecurityOption2 | undefined;
};

export type UpdateSigintSignalRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateSigintSignalForm: UpdateSigintSignalForm;
};

/** @internal */
export type UpdateSigintSignalSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateSigintSignalSecurityOption1$outboundSchema: z.ZodMiniType<
  UpdateSigintSignalSecurityOption1$Outbound,
  UpdateSigintSignalSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateSigintSignalSecurityOption1ToJSON(
  updateSigintSignalSecurityOption1: UpdateSigintSignalSecurityOption1,
): string {
  return JSON.stringify(
    UpdateSigintSignalSecurityOption1$outboundSchema.parse(
      updateSigintSignalSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateSigintSignalSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateSigintSignalSecurityOption2$outboundSchema: z.ZodMiniType<
  UpdateSigintSignalSecurityOption2$Outbound,
  UpdateSigintSignalSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function updateSigintSignalSecurityOption2ToJSON(
  updateSigintSignalSecurityOption2: UpdateSigintSignalSecurityOption2,
): string {
  return JSON.stringify(
    UpdateSigintSignalSecurityOption2$outboundSchema.parse(
      updateSigintSignalSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateSigintSignalSecurity$Outbound = {
  Option1?: UpdateSigintSignalSecurityOption1$Outbound | undefined;
  Option2?: UpdateSigintSignalSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateSigintSignalSecurity$outboundSchema: z.ZodMiniType<
  UpdateSigintSignalSecurity$Outbound,
  UpdateSigintSignalSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateSigintSignalSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateSigintSignalSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateSigintSignalSecurityToJSON(
  updateSigintSignalSecurity: UpdateSigintSignalSecurity,
): string {
  return JSON.stringify(
    UpdateSigintSignalSecurity$outboundSchema.parse(updateSigintSignalSecurity),
  );
}

/** @internal */
export type UpdateSigintSignalRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateSigintSignalForm: UpdateSigintSignalForm$Outbound;
};

/** @internal */
export const UpdateSigintSignalRequest$outboundSchema: z.ZodMiniType<
  UpdateSigintSignalRequest$Outbound,
  UpdateSigintSignalRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateSigintSignalForm: UpdateSigintSignalForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      updateSigintSignalForm: "UpdateSigintSignalForm",
    });
  }),
);

export function updateSigintSignalRequestToJSON(
  updateSigintSignalRequest: UpdateSigintSignalRequest,
): string {
  return JSON.stringify(
    UpdateSigintSignalRequest$outboundSchema.parse(updateSigintSignalRequest),
  );
}
